import React from 'react'
import {CommissionWalletRowProps} from './types'

/**
 * Commission wallet row — always a checkbox (add-on to reduce total).
 * Hidden on signup (walletMode='hidden' in parent).
 * Disabled when balance is 0.
 */
export function CommissionWalletRow({
  balance,
  checked,
  onChange,
}: CommissionWalletRowProps) {
  const formattedBalance = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(balance)

  return (
    <>
      <div className='py-1'>
        <div className='py-3 d-flex flex-stack flex-nowrap'>
          <div className='d-flex align-items-center flex-grow-1 min-w-0'>
            <div className='me-3'>
              <div className='d-flex align-items-center fw-bolder'>
                Commission Wallet
              </div>
              <div className='text-muted'>
                Available balance: {formattedBalance}
              </div>
            </div>
          </div>

          <div className='d-flex align-items-center ms-2 ms-md-9 flex-shrink-0'>
            <label className='form-check form-check-custom form-check-solid'>
              <input
                className='form-check-input'
                type='checkbox'
                checked={checked}
                disabled={balance === 0}
                onChange={(e) => onChange(e.target.checked)}
              />
            </label>
          </div>
        </div>
      </div>
      <div className='separator separator-dashed'></div>
    </>
  )
}
